<procure-badge
  [label]="label()"
  [backgroundColor]="backgroundColor()"
/>
